var _excluded = ["single", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable max-len */
import { chakra, forwardRef, useStyles } from '@chakra-ui/system';
import { __DEV__, cx } from '@chakra-ui/utils';
import * as React from 'react';
export var ModalFooter = forwardRef((props, ref) => {
  var {
    single = false,
    className
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var _className = cx('chakra-modal__footer', className);

  var styles = useStyles();

  var childStyles = () => {
    if (single) {
      return {
        '> button': {
          width: {
            base: '100%',
            md: 'auto'
          }
        }
      };
    }

    return {
      '> button': {
        width: {
          base: '100%',
          md: 'auto'
        }
      },
      '> *:first-of-type:not(:last-of-type)': {
        marginRight: {
          base: 0,
          md: 4
        },
        marginBottom: {
          base: 4,
          md: 0
        }
      }
    };
  };

  var footerStyles = _extends({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }, childStyles(), styles.footer);

  return /*#__PURE__*/React.createElement(chakra.footer, _extends({}, rest, {
    __css: footerStyles,
    className: _className,
    flexDir: {
      base: 'column',
      md: 'row'
    },
    ref: ref
  }));
});

if (__DEV__) {
  ModalFooter.displayName = 'ModalFooter';
}
//# sourceMappingURL=modal-footer.js.map